<template>

	<div :class="{'hide': loading}" style="overflow: hidden;">
		<div :class="{'spinner loading': loading}"></div>

		<form class="widget-form" method="GET" action="/order">
			<label for="type" class="select-block">
				<div class="order-form-home-label">Type of paper</div>
				<select v-model="type" id="type" name="type">
					<option v-for="(singleType, index) in $types" v-bind:value="index">
						{{singleType}}
					</option>
				</select>
				<!-- SVG ARROW -->
				<svg class="svg-arrow">
					<use xlink:href="#svg-arrow"></use>
				</svg>
				<!-- /SVG ARROW -->
			</label>

			<label for="deadline" class="select-block deadline">
				<div class="order-form-home-label">Deadline</div>
				<select v-model="deadline"
						@change="calculate()"
						id="deadline"
						name="deadline">
					<option v-for="(singleDeadline, index) in $deadlines" v-bind:value="index">
						{{singleDeadline}}
					</option>
				</select>
				<!-- SVG ARROW -->
				<svg class="svg-arrow">
					<use xlink:href="#svg-arrow"></use>
				</svg>
				<!-- /SVG ARROW -->
			</label>

			<label for="quality" class="select-block quality">
				<div class="order-form-home-label">Academic Level</div>
				<select v-model="quality"
						@change="calculate()"
						id="quality"
						name="quality">
					<option v-for="(singleQuality, index) in $qualities" v-bind:value="index">
						{{singleQuality}}
					</option>
				</select>
				<!-- SVG ARROW -->
				<svg class="svg-arrow">
					<use xlink:href="#svg-arrow"></use>
				</svg>
				<!-- /SVG ARROW -->
			</label>

			<label for="pages" class="select-block pages">
				<div class="order-form-home-label">Pages</div>
				<div id="plus-minus" class="plus-minus">

					<div id="main-pages-qty" class="contentspin clearfix">
						<input v-on:click="pagesMinus" class="buttonspin qtyminus" value="−" type="button">
						<input v-model="pages"
							   @change="calculate()"
							   class="ui-spinner"
							   name="pages" id="pages" type="text">
						<input v-on:click="pagesPlus" class="buttonspin qtyplus" value="+" type="button">
					</div>
				</div>
			</label>


			<div class="select-block total-price-container">
				<div class="total-price-calculated">
					<div class="price-label">Total price</div>
					<div class="price">${{price}}</div>
				</div>

			</div>


			<button class="button medium dark" id="call-to-action home">Write My Paper!</button>


		</form>

</div>
</template>


<script>
    import { required, email, minLength, sameAs, between } from 'vuelidate/lib/validators'
	import moment from 'moment';
    import pricingMixin from '../../../Mixins/pricingMixin.js';
    import plusMinusButtonsMixin from '../../../Mixins/plusMinusButtonsMixin';




    export default {
        mixins: [pricingMixin, plusMinusButtonsMixin],
        props: [],
        data() {
            return {

                deadline: '7',
                pages: '1',
                type: '1',
                quality: '1',

                wordCount: 550,
                price: 0,
                pricePerPage: 0,




                loading: true,


            }
        },

        created(){
            this.loading = false;
            this.calculate();

        },

        watch: {
            pages() {
                this.calculate();
            },
            deadline() {
                this.calculate();
            },
            quality() {
                this.calculate();
            },

        },

        methods: {
            calculate: function () {
                this.calculatePrice();
            },

			calculatePrice: function() {
                this.pricePerPage = this.priceCalculation(this.deadline, this.quality);
                this.price = this.pricePerPage * this.pages;
			},


        },
    }
</script>